import debounce from "../helpers/debounce";
import {getSiblings} from "../helpers/dom";

export default class MagicLine {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.elements = this.wrapper.querySelectorAll('.navigation-menu li');
    let element = this.wrapper.querySelector('.navigation-menu li.active');
    this.line = this.wrapper.querySelector('.line');
    this.flag = !!element;
    if (!this.flag) {
      element = this.elements[0];
      this.line.classList.add('inactive');
    }
    this.thumb = this.line.querySelector('.line-thumb');
    this.current = {
      element: element,
      position: this.getPosition(element),
      width: this.getWidth(element)
    };

    Array.prototype.forEach.call(this.elements, el => {
      if (!!el) {
        el.addEventListener('mouseenter', (e) => {
          if (e.currentTarget.classList.contains('bookmarks')) return;
          if (!this.flag) this.line.classList.remove('inactive');
          this.setPosition(e.currentTarget);
        }, false);

        el.addEventListener('mouseleave', () => {
          this.setPosition(this.current.element);
          if (!this.flag) this.line.classList.add('inactive');
        }, false);

        el.addEventListener('click', (e) => {
          if (e.currentTarget.classList.contains('bookmarks')) return;
          if (this.flag) this.line.classList.remove('inactive');
          this.flag = true;
          el.parentElement.classList.add('active');
          Array.prototype.forEach.call(getSiblings(el.parentElement), parent => {
            parent.classList.remove('active');
          });

          this.setPosition(e.currentTarget, true);
        }, false);
      }
    });

    window.addEventListener('resize', debounce(() => {
      this.setPosition(this.current.element, true);
    }, 100));

    window.addEventListener('load', () => {
      this.setPosition(this.current.element, true);
    });

    this.setPosition(element);
  }

  setPosition(el, flag) {
    let position = this.getPosition(el);
    let left = position.left + 15;
    let top = position.top;
    let width = this.getWidth(el);

    if (this.thumb.style.left === (left + 'px') && this.thumb.style.top === (top + 'px') && !flag) return;
    if (this.thumb.style.top !== (top + 'px')) {
      setTimeout(() => {
        this.thumb.style.opacity = .075;
      }, 100);
      setTimeout(() => {
        this.thumb.style.opacity = 1;
      }, 400);
    }

    this.thumb.style.left = left + 'px';
    this.thumb.style.top = top + 'px';
    this.thumb.style.width = width + 'px';

    if (flag) {
      this.current.element = el;
      this.current.position = position;
      this.current.width = width;
    }
  }

  getWidth(el) {
    if (!el) el = this.current.element;
    return parseFloat(window.getComputedStyle ? window.getComputedStyle(el, null).getPropertyValue('width') : el.currentStyle.width) - (!!window.document.documentMode ? 0 : 50);
  }

  getPosition(el) {
    if (el) return {left: el.offsetLeft - 5, top: el.offsetTop};
    return {left: this.current.element.offsetLeft - 5, top: el.offsetTop};
  }
}
